import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      id: item.id,
      title: item.title,
      content: item.content,
      created_at: item.created_at,
      updated_at: item.updated_at,
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getBatchMessageTemplates({ payload: { signal, searchQ, curr_page } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.sendbird.templates.list,
      params: {
        page: curr_page,
        q: searchQ,
        ordering: '-created_at'
      },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getBatchMessageTemplatesDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getBatchMessageTemplatesFailed,
      endpoint: api.sendbird.templates.list.url
    });
  }
}

export const getBatchMessageTemplatesSaga = takeEvery(types.GET_BATCH_MESSAGE_TEMPLATES_REQUEST, getBatchMessageTemplates);